import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GoogleButton from 'react-google-button';

import EmailPasswordControlSet from '../../ControlSets/EmailPasswordControlSet/EmailPasswordControlSet';
import { UamErrorText, UamErrorTextContainer } from '../../../../styles-and-themes/styles/uam-registration-styles';
import LoginForgotControlSet from '../../ControlSets/LoginForgotControlSet/LoginForgotControlSet';
import { composeDestinationQuerystring } from '../../../../../shared-with-server/destination-utils';
import { destinationInfo } from '../../../../destructured-front-end-config';
import { GoogleButtonContainer } from './LoginPanelStyles';

const LoginPanel = ({
  destPath, errorMessage, setSubmitData, includeGoogleSignIn,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const isFormValid = email.length > 0 && password.length > 0;

  return (
    <>
      <UamErrorTextContainer>
        <UamErrorText>
          {errorMessage || 'All fields are required'}
        </UamErrorText>
      </UamErrorTextContainer>

      <EmailPasswordControlSet
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
      />

      <LoginForgotControlSet
        onLogin={() => {
          setSubmitData({
            email,
            password,
            ...(destPath),
          });
        }}
        isFormValid={isFormValid}
        destPath={destPath}
      />
      {
        includeGoogleSignIn && (
          <GoogleButtonContainer>
            <GoogleButton onClick={() => {
              window.location.href = `/auth/google?${composeDestinationQuerystring(destinationInfo, destPath)}`;
            }}
            />
          </GoogleButtonContainer>
        )
      }
    </>
  );
};

LoginPanel.propTypes = {
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
  setSubmitData: PropTypes.func.isRequired,
  includeGoogleSignIn: PropTypes.bool.isRequired,
};

LoginPanel.defaultProps = {
  errorMessage: null,
};

export default LoginPanel;
